// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__l1rA4","inner":"Form_inner__1AMl1","range":"Form_range__3W4S0","name":"Form_name__1aPDX","actions":"Form_actions__2ZQ7p"};